<script>
  import SrsMonitor from "../components/SRSMonitor.svelte";
	import { api } from "../api";
	import FlightContext from "../flight/FlightContext.svelte";
	import Bounds from "../flight/Bounds.svelte";
	import OwnshipMarker from "../flight/OwnshipMarker.svelte";
	import OwnshipTrail from "../flight/OwnshipTrail.svelte";
	import '../flight/regionADSB'

	const promise = api.flights.get()
	const flights = api.flights.store
</script>

<svelte:head>
	<title>SkyLine - Map</title>
</svelte:head>

<SrsMonitor/>

{#await promise then _}
	{#each Object.values($flights) as flight}		
		{#if flight.state == "ACTIVE"}
			<FlightContext {flight} multiFlight>
				<Bounds/>
				<OwnshipMarker/>
				<OwnshipTrail/>
			</FlightContext>
		{/if}
	{/each}
{/await}